import { render, staticRenderFns } from "./takeNumberResult.vue?vue&type=template&id=e0080072&scoped=true&"
import script from "./takeNumberResult.vue?vue&type=script&lang=js&"
export * from "./takeNumberResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0080072",
  null
  
)

export default component.exports